import React from "react";
import { ExclamationTriangleIcon, TrashIcon, WrenchScrewdriverIcon, QrCodeIcon } from "@heroicons/react/24/outline";
import { CartSummarySkeleton } from "./FulfillmentSkeletons";

export default function OrderItemsList({
    items: propItems,
    selectedOrder,
    cartLoading,
    cartError,
    actionSubmitting,
    handleRemoveFromDelivery,
    setDamageRemoveFromOrder,
    handleCardAction,
    handleClearActions,
    handleSubmitAction
}) {
    const items = propItems !== undefined ? propItems : (selectedOrder?.items || []);

    console.log(
        "OrderItemsList Props",
        items
    );

    if (cartLoading) {
        return <CartSummarySkeleton />;
    }

    if (cartError) {
        return (
            <div className="bg-red-50 border border-red-200 p-5 rounded-lg text-red-700 text-xs flex flex-col items-center justify-center py-10">
                <ExclamationTriangleIcon className="h-6 w-6 text-red-500 mb-2" />
                <p className="font-semibold">Failed to load cart summary</p>
                <p className="mt-1 text-gray-600">{cartError}</p>
            </div>
        );
    }

    if (!items || items.length === 0) {
        return (
            <div className="bg-white border border-gray-200 rounded-xl shadow-xs p-10 flex flex-col items-center justify-center text-center">
                <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center mb-4 text-blue-600">
                    <QrCodeIcon className="w-8 h-8 stroke-[1.5]" />
                </div>
                <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wider">
                    Packing List is Empty
                </h3>
                <p className="text-xs text-gray-500 mt-2 max-w-sm font-medium leading-relaxed">
                    Scan a book's Copy ID and add a book to start packing for delivery.
                </p>
            </div>
        );
    }

    return (
        <div className="bg-white border border-gray-200 rounded-lg shadow-xs overflow-hidden">
            <div className="px-5 py-4 border-b border-gray-150 bg-gray-50/50">
                <h3 className="text-sm font-bold text-gray-800 uppercase tracking-wider">
                    Items List
                </h3>
            </div>

            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200 text-left text-xs">
                    <thead className="bg-gray-50/30 text-gray-500 font-bold tracking-wider">
                        <tr>
                            <th className="px-6 py-3 text-xs font-bold w-24">Product</th>
                            <th className="px-6 py-3 text-xs font-bold">Description</th>
                            <th className="px-6 py-3 text-xs font-bold w-36">Status</th>
                            <th className="px-6 py-3 text-xs font-bold w-36">SubTotal</th>
                            <th className="px-6 py-3 text-xs font-bold w-48 text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                        {items.map((item, idx) => {
                            const itemImage = item.image || item.img || "https://via.placeholder.com/80x120?text=Cover";
                            const itemTitle = item.name || item.title || "Unknown Item";
                            const itemCredits = item.credits || item.price || 0;
                            const itemStatus = item.issue_or_return || item.status || "issue";
                            const itemStatusClean = String(itemStatus).toLowerCase();
                            const isReturning = ["return", "returning", "returned"].includes(itemStatusClean);
                            const itemType = item.product_type || item.type || "Book";
                            const itemId = item.product_id || item.id || idx;

                            return (
                                <tr key={itemId} className="hover:bg-gray-50/50 transition-colors">
                                    {/* Product Image Column */}
                                    <td className="px-4 py-2 whitespace-nowrap align-middle">
                                        <img
                                            src={itemImage}
                                            alt={itemTitle}
                                            className="w-16 h-24 object-cover rounded border border-gray-200 shadow-2xs"
                                        />
                                    </td>

                                    {/* Description Column */}
                                    <td className="px-6 py-4 align-middle">
                                        <div className="space-y-1">
                                            <div className="font-bold text-gray-900 text-sm">{itemTitle}</div>
                                            <div className="text-gray-500 space-y-0.5 leading-relaxed">
                                                <p>Product ID: <span className="font-semibold text-gray-700">{itemId}</span></p>
                                                <p>Type: <span className="font-semibold text-gray-700">{itemType}</span></p>
                                                <p>Qty: <span className="font-semibold text-gray-700">{item.quantity || 1}</span></p>
                                            </div>
                                        </div>
                                    </td>

                                    {/* Status Column */}
                                    <td className="px-6 py-4 align-middle whitespace-nowrap">
                                        <div className="pt-1">
                                            <span className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider ${isReturning
                                                ? "bg-amber-50 text-amber-700 border border-amber-100"
                                                : "bg-blue-50 text-blue-700 border border-blue-100"
                                                }`}>
                                                {item.issue_or_return || "issue"}
                                            </span>
                                        </div>
                                    </td>

                                    {/* SubTotal Column */}
                                    <td className="px-6 py-4 align-middle whitespace-nowrap">
                                        <span className="text-sm font-bold text-gray-900">
                                            {itemCredits} Credit{Number(itemCredits) !== 1 ? "s" : ""}
                                        </span>
                                    </td>

                                    {/* Actions Column */}
                                    <td className="px-6 py-4 align-middle whitespace-nowrap text-right">
                                        <div className="inline-flex flex-col gap-2">
                                            <button
                                                disabled={actionSubmitting}
                                                onClick={() => {
                                                    setDamageRemoveFromOrder(false);
                                                    handleCardAction(item, "damaged");
                                                }}
                                                className="inline-flex items-center justify-center gap-1 px-3 py-1.5 rounded-lg border border-orange-200 text-orange-700 bg-orange-50/30 hover:bg-orange-50 hover:text-orange-800 disabled:opacity-50 transition-all font-medium"
                                            >
                                                <WrenchScrewdriverIcon className="h-3.5 w-3.5" />
                                            </button>

                                            <button
                                                disabled={actionSubmitting}
                                                onClick={() => {
                                                    if (window.confirm(`Are you sure you want to remove "${itemTitle}" from delivery?`)) {
                                                        handleRemoveFromDelivery(item);
                                                    }
                                                }}
                                                className="inline-flex items-center justify-center gap-1 px-3 py-1.5 rounded-lg border border-red-200 text-red-700 bg-red-50/30 hover:bg-red-50 hover:text-red-800 disabled:opacity-50 transition-all font-medium"
                                            >
                                                <TrashIcon className="h-3.5 w-3.5" />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            {/* Action Buttons Footer */}
            <div className="px-5 py-4 border-t border-gray-150 bg-gray-50/50 flex justify-end gap-3">
                <button
                    disabled={actionSubmitting}
                    onClick={handleClearActions}
                    className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 hover:text-gray-900 transition active:scale-95 disabled:opacity-50"
                >
                    Clear Actions
                </button>
                <button
                    disabled={actionSubmitting}
                    onClick={handleSubmitAction}
                    className="px-4 py-2 bg-black text-white hover:bg-gray-900 rounded-lg text-sm font-bold transition active:scale-95 disabled:opacity-50"
                >
                    Submit Action
                </button>
            </div>
        </div>
    );
}
